import { useLocation } from 'react-router';
import { helpText } from '@kontor/shared';
import { HELP_HOME, helpUrl } from '../links';
import { InfoHint } from './InfoHint';

/**
 * Kurzhilfe zur aktuellen Seite: ein „i“ am Menüeintrag, das beim Darüberfahren, per Tastatur oder Antippen ein kleines Fenster öffnet. Es nennt, wozu die Seite da ist, und die
 * ersten Schritte. Am Ende führt „Detaillierte Hilfe“ zum ausführlichen Artikel der Anleitung auf der Webseite. Die Texte stammen aus den Artikeln (packages/shared/src/help-texts.ts,
 * erzeugt von tools/anleitung/sync-help.mjs).
 */
export function PageHelp() {
  const { pathname } = useLocation();
  const help = helpText(pathname);
  const link = (
    <a href={helpUrl(pathname)} target="_blank" rel="noopener noreferrer">
      Detaillierte Hilfe<span className="sr-only"> (öffnet die Anleitung in neuem Tab)</span> →
    </a>
  );
  return (
    <InfoHint label="dieser Seite" className="pagehelp">
      {help ? (
        <>
          <strong>{help.title}</strong>
          <p>{help.summary}</p>
          {help.steps.length > 0 && (
            <>
              <p className="pagehelp__label">{help.isArea ? 'Dazu gibt es:' : 'So geht es:'}</p>
              {help.isArea ? (
                <ul>{help.steps.map((s) => <li key={s}>{s}</li>)}</ul>
              ) : (
                <ol>{help.steps.map((s) => <li key={s}>{s}</li>)}</ol>
              )}
            </>
          )}
          {link}
        </>
      ) : (
        <>
          <p>Zu dieser Seite gibt es noch keine eigene Anleitung. Die Übersicht mit Suche finden Sie auf der Webseite.</p>
          <a href={HELP_HOME} target="_blank" rel="noopener noreferrer">Zur Anleitung →</a>
        </>
      )}
    </InfoHint>
  );
}
